import { useMemo, useRef, useState } from "react";
import { TabPanel, TabPanelTab } from "ui/components/common/TabPanel";
import { useGameDifficulties } from "../../hooks/useGameDifficulties";
import { Store } from "game/store/gameStore";
import { UIRootState } from "ui/store/reducers";
import { useSelector } from "react-redux";
import { translate } from "game/translate";
import './styles.css';
import { DifficultiesList } from "../DifficultiesList";

export const NewGameTabPanel = ({ footerHeight, modalRef, gameUiRef }: { footerHeight: number, modalRef: React.RefObject<HTMLDivElement>, gameUiRef?: React.RefObject<HTMLDivElement> }) => {

    const state = useSelector((state: UIRootState) => state.gameUI.modals.newGameModal);
    const contentRef = useRef<HTMLDivElement | null>(null);
    const gameDifficulties = useGameDifficulties();

    const config = useMemo(() => gameDifficulties[Store.name], [gameDifficulties, Store.name]);

    const displayWithoutTabs = useMemo(() => config && !!config.find(x => !x.title), [config]);

    const initialTab = useMemo(() => {
        const current = config.find(x => x.difficulties.find(d => d.type === Store.difficulty));
        if (current) {
            return current.key;
        }

        return config[0]?.key;
    }, [config]);

    const [activeTab, setActiveTab] = useState<string | undefined>(initialTab || config[0].key);

    const tabsConfig: Array<TabPanelTab & { key: string }> = useMemo(() => config.filter(x => x.key).map(item => ({
        key: item.key || '',
        title: item.title || '',
        content: <DifficultiesList difficulties={item.difficulties} dataDraw={item.dataDraw} dataSuit={item.dataSuit} modalRef={modalRef} gameUiRef={gameUiRef} activeTabKey={activeTab} />,
    })), [config, activeTab]);

    const contentKey = useMemo(() => `${activeTab}-${state?.isOpen ? 'open' : 'closed'}`, [activeTab, state?.isOpen]);

    const tabsVariantClass = useMemo(() => {
        return tabsConfig.length === 3 ? 'design-tabs--three' : 'design-tabs--two';
    }, [tabsConfig]);


    const handleChange = (key: string) => {
        setActiveTab(key);
    };

    return (
        <div className="d-flex flex-column" style={{ maxHeight: `calc(100% - ${footerHeight + 49}px)`, height: '100%' }}>
            {!displayWithoutTabs && <span className="newgame-tab-title">{translate('draw_mode')}</span>}
            <TabPanel
                tabs={tabsConfig}
                activeKey={activeTab || ''}
                displayWithoutTabs={displayWithoutTabs}
                onChange={handleChange}
                tabsBarClassName={`stories-tabs design-tabs d-flex rounded-pill p-1 position-relative ${tabsVariantClass}`}
                activeIndexClassPrefix="design-tabs--active-"
                tabButtonClassName={`modal-tab${Store.language === 'fr' ? ' modal-tab--smaller' : ''}`}
                showIndicator
                contentWrapperClassName={`newgame-tab-panel-content design-content--no-padding overflow-auto stories-content w-100`}
                contentKey={contentKey}
                disabledBtnClassName="modal-tab--disabled"
                rootClassName="newgame-tab-panel-container"
                scrollRef={contentRef}
            />
        </div>
    );
};